export default __webpack_public_path__ + "static/media/IMG_0829.1acde896.jpg";